import React, { Component, createContext } from 'react'
import { Teammates } from 'models'
import { getPhoneCom } from 'phonecom'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props {}
interface TeammateProviderState {
    teammates: Teammates;
    loaded: boolean;
    isLoading: boolean;
}

/***/
export const TeammateContext = createContext<any>({})

/**
 *
 */
export const TeammateConsumer = TeammateContext.Consumer

class TeammateProvider extends Component<Props, TeammateProviderState> {
    /**
     * @param props
     */
    constructor (props) {
        super(props)
        this.state = {
            teammates: new Teammates(),
            loaded: false,
            isLoading: false
        }
    }

    /**
     *
     */
    componentDidMount () {
        this.load()
    }

    list = async (filter = ''): Promise<Teammates> => {
        await this.load()
        let res = this.state.teammates
        if (filter) {
            res = res.filter(filter)
        }
        return res
    }

    next = async (cursor: string): Promise<Teammates> => {
        return Teammates.load(cursor).then(
            res => {
                this.update(res)
                return res
            }
        )
    }

    load = async (): Promise<void> => {
        let res: Teammates = new Teammates()
        if (!this.state.loaded && !this.state.isLoading) {
            this.setState({ isLoading: true })
            await getPhoneCom()
            res = await Teammates.load(this.state.teammates.cursor)
            this.update(res)
            await this.setState({ teammates: res, loaded: true, isLoading: false })
            console.log('providers load teammates:', this.state.teammates)
        }
    }

    update = async (teammates: Teammates): Promise<any> => {
        const updated = this.state.teammates.update(teammates)
        this.setState({ teammates: updated })
    }

    hasExtension = (ext: number) : boolean => {
        return this.state.teammates.contains(ext)
    }

    /**
     *
     */
    render () {
        const { list, next, hasExtension } = this
        const { loaded, teammates } = this.state
        // let { displayNames } = this.state
        return (<TeammateContext.Provider value={{
            list,
            next,
            hasExtension,
            teammates,
            loaded
        }}>
            {this.props.children}
        </TeammateContext.Provider>)
    }
}

export default TeammateProvider
